import React, { useEffect, useState } from 'react';
import { isLastElement } from 'globals/utils';
import FsTileTab from './FsTileTab';
import { TileTabProps } from './FsTileTab/FsTileTab';
import { ContainerBox } from './FsTileTabs.style-elements';

export interface ActiveTab {
  idx: number;
  id: string;
  label: string;
}

export interface TileTabsProps {
  tabs: TileTabProps[];
  onUpdate: (newActiveTabs: ActiveTab[]) => void;
}

const FsTileTabs: React.FC<TileTabsProps> = ({ tabs, onUpdate }) => {
  const [tabList, setTabList] = useState<TileTabProps[]>(tabs);

  const clickHandler = (id: string, isActive: boolean): void => {
    const newTabList = tabList.map((tabData) => ({
      ...tabData,
      isActive: tabData.id === id ? isActive : tabData.isActive,
    }));
    setTabList(newTabList);
  };

  useEffect(() => {
    const activeTabs = tabList
      .map(({ label, id, isActive }, idx) => ({
        label,
        id,
        idx,
        isActive,
      }))
      .filter((tab) => tab.isActive);

    onUpdate(activeTabs);
  }, [tabList, onUpdate]);

  return (
    <ContainerBox>
      {tabList.map(({ id, ...props }, idx) => (
        <FsTileTab
          {...props}
          key={id}
          id={id}
          isLast={isLastElement(idx, tabList.length)}
          onClick={(isActive: boolean): void => clickHandler(id, isActive)}
        />
      ))}
    </ContainerBox>
  );
};

export default FsTileTabs;
